import { memo } from 'react';

import { FileStatusIconErrored, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type AssetTaggingTaskFailedPanelItemProps = {
  onClear: () => void;
};

export const AssetTaggingTaskFailedPanelItem = memo(({ onClear }: AssetTaggingTaskFailedPanelItemProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();

  return (
    <PaneItemTW
      avatar={<FileStatusIconErrored size={getTaskPaneFileStatusIconSize(ui2026)} />}
      title={
        <FileStatusTitle data-testid="ASSET_TAGGING_TASK_FAILED_PANEL_ITEM_TITLE">
          {ui2026 ? 'Couldn’t update tags' : 'Failed to update items'}
        </FileStatusTitle>
      }
      buttons={<TaskPaneDismissButton label="Clear" onClick={onClear} />}
    />
  );
});

AssetTaggingTaskFailedPanelItem.displayName = 'AssetTaggingTaskFailedPanelItem';
